import React from 'react';
import { Provider } from 'react-redux';

import Base from './Base.jsx';

import AssetChart from '../Components/AssetChart/index.jsx';

import Store from '../Store/index.js';


class EntryPoint extends Base {
  id() {
    return 'cs-asset-chart';
  }

  renderElement(element) {
    var id = element.dataset.id;

    return (
      <Provider store={Store}>
        <AssetChart id={id} />
      </Provider>
    );
  }
}


export default EntryPoint;

